import {
  parkingIcon,
  footwearIcon,
  sweatIcon,
  storeIcon,
  yogaMatIcon,
  hemmingAlterationsIcon,
  towelServiceIcon,
  premiumShowersIcon,
  gearTrialIcon,
  wifiIcon,
  changeRoomIcon,
  tuneBedsIcon,
  meditationAreaIcon,
  eventSpaceIcon
} from "@lululemon/dsp-ecom-pattern-library";
export default {
  studio_services: {
    iconName: "store",
    icon: storeIcon,
    text: "Studio services"
  },
  sweat_studios: { iconName: "sweat_studios", text: "Fitness Studio" },
  event_space: {
    iconName: "eventSpace",
    icon: eventSpaceIcon,
    text: "Event space"
  },
  meditation_space: {
    iconName: "meditationSpace",
    icon: meditationAreaIcon,
    text: "Meditation space"
  },
  tune_beds: { iconName: "tuneBeds", icon: tuneBedsIcon, text: "Tune beds" },
  change_rooms: {
    iconName: "changeRoom",
    icon: changeRoomIcon,
    text: "Change rooms"
  },
  lounge_and_workspace: {
    iconName: "loungeWorkspace",
    text: "Lounge & workspace"
  },
  fuel_space: { iconName: "fuelSpace", text: "Fuel space" },
  wifi: { iconName: "wifi", icon: wifiIcon, text: "Free Wi-Fi" },
  gear_trial_program: {
    iconName: "gearTrial",
    icon: gearTrialIcon,
    text: "Gear trial program"
  },
  hemming_and_alterations: {
    iconName: "hemming",
    icon: hemmingAlterationsIcon,
    text: "Hemming & alterations"
  },
  premium_showers: {
    iconName: "premiumShower",
    icon: premiumShowersIcon,
    text: "Premium showers"
  },
  towel_service: {
    iconName: "towelService",
    icon: towelServiceIcon,
    text: "Towel service"
  },
  hemming: {
    iconName: "hemming",
    icon: hemmingAlterationsIcon,
    text: "Free Hemming"
  },
  power_outlets: { iconName: "bulletPoint", text: "Power outlets" },
  training_equipment: {
    iconName: "trainingEquipment",
    text: "Training equipment"
  },
  meditation_seats: { iconName: "bulletPoint", text: "Meditation seats" },
  mats_and_blocks: {
    iconName: "matsAndBlocks",
    icon: yogaMatIcon,
    text: "Mats & blocks"
  },
  pre_order_online: {
    iconName: "store",
    icon: storeIcon,
    text: "Buy & Pick-Up"
  },
  grab_and_go_items: { iconName: "grabAndGo", text: "Grab & go items" },
  available_for_rental: {
    iconName: "availableForRental",
    text: "Available for rental"
  },
  chairs: { iconName: "bulletPoint", text: "Chairs" },
  co_working_space: { iconName: "bulletPoint", text: "Co-working space" },
  kitchenette: { iconName: "bulletPoint", text: "Kitchenette" },
  microphones: { iconName: "microphones", text: "Microphones" },
  projector: { iconName: "projector", text: "Projector" },
  seating: { iconName: "seating", icon: sweatIcon, text: "Seating" },
  footwear: { iconName: "footwear", icon: footwearIcon, text: "Shoes" },
  free_parking: {
    iconName: "parking_icon",
    icon: parkingIcon,
    text: "Free parking"
  }
};
